import request from '@/utils/request'

/**
 *获取订单列表
 * @param {*} data 
 */
export function getWayBillList(data){
    return request({
        url: '/report/order',
        method: 'post',
        data
    })
}

/**
 *获取员工列表
 * @param {*} data 
 */
 export function getCustomerList(data){
    return request({
        url: '/user/select/list',
        method: 'post',
        data
    })
}

/**
 *获取员工列表
 * @param {*} data 
 */
 export function getUserBalance(data){
    return request({
        url: '/report/balance',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/statistical.js